module.exports = __webpack_public_path__ + "img/usdt_tethertether.5b1ced6.png";